import { combineReducers } from 'redux';

import { IImage } from '../../api/images';
import { Actions, ActionTypes } from './actions';

export const remove = (images: IImage[], deleted: IImage[]) => {
	const ids = deleted.map((i) => i.id);
	return images.filter((i) => !ids.includes(i.id));
};

export const merge = (current: IImage[], next: IImage[]) => {
	return current.map((img) => {
		return next.find((i) => i.id === img.id) || img;
	});
};

export const byPropertyId = (state = {} as { [key: string]: IImage[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.IMAGES_GET_BY_PROPERTY_ID_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.images };
		case ActionTypes.IMAGES_SET_ORDER_FOR_PROPERTY_RECEIVE:
			return { ...state, [action.payload.id]: merge(state[action.payload.id], action.payload.images) };
		case ActionTypes.IMAGES_GET_BY_PROPERTY_ID_FAILURE:
			return { ...state, [action.payload.id]: [] };
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_RECEIVE:
			return { ...state, [action.payload.id]: remove(state[action.payload.id], action.payload.result) };
		case ActionTypes.IMAGES_UPLOAD_RECEIVE:
			const next = (state[action.payload.id] || []).slice(0);
			next.unshift(...action.payload.uploaded);
			return { ...state, [action.payload.id]: next };
		case ActionTypes.IMAGES_SET_ORDER_FOR_PROPERTY_REQUEST:
			return { ...state, [action.payload.id]: merge(state[action.payload.id], action.payload.images) };
		default:
			return state;
	}
};

export interface IImagesState {
	byPropertyId: ReturnType<typeof byPropertyId>;
}

const user = combineReducers<IImagesState>({
	byPropertyId
});

export default user;
